import { combineReducers } from 'redux';
import block from './block/blockReducer';

export default combineReducers({
	block,
});
